import React from 'react';
import { useTheme } from './components/basic/ThemeProvider';
import Typography from './components/basic/Typography';
import { Button } from './components/basic/Button';

interface ComingSoonPageProps {
  title: string;
  description: string;
}

const ComingSoonPage: React.FC<ComingSoonPageProps> = ({ title, description }) => {
  const { theme } = useTheme();

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      padding: '2rem',
      textAlign: 'center',
      backgroundColor: theme.colors.bg.primary,
      color: theme.colors.fg.primary
    }}>
      <Typography
        variant="display1"
        align="center"
        gutterBottom
        style={{ fontSize: '4rem', marginBottom: '1rem' }}
      >
        🚧
      </Typography>

      <Typography
        variant="h1"
        align="center"
        gutterBottom
        color="primary"
      >
        {title}
      </Typography>

      <Typography
        variant="body-large"
        align="center"
        color="secondary"
        style={{ maxWidth: '600px', marginBottom: '2rem' }}
      >
        {description}
      </Typography>

      <Button
        variant="contained"
        color="primary"
        size="large"
        href="/game/"
        iconStart="←"
      >
        Back to Home
      </Button>
    </div>
  );
};

export default ComingSoonPage;